import { Button, Dropdown, Menu, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";
import Helper from "../../core/Helper";
import { useEffect, useState } from "react";

/**
 * Yazdırma menüsündeki form etiketleri.
 *
 * Kural: adı varsa ad, yoksa dil. Ama **iki form aynı etikete düşerse ayırt edilemez** — sahada
 * tam bu oldu: adı olmayan iki Türkçe form da "Türkçe" görünüyordu. Bu yüzden etiketler liste
 * bazında hesaplanır ve tekrar edenlere "#id" eklenir.
 *
 * Kalıcı çözüm forma isim vermektir (Birim → Formlar → Ad). Bu fonksiyon yalnızca isimsiz eski
 * kayıtların ayırt edilebilir kalmasını sağlar.
 */
const buildFormLabels = (forms = []) => {
    const base = forms.map((form) => {
        const name = (form?.name || '').replace(/^Dil:\s*/i, '').trim()

        const code = form?.language
        // 2-3 karakterse ISO kodudur (tr/en); daha uzunsa eski serbest metin, aynen gösterilir.
        const language = code ? (code.length <= 3 ? t(`lang_${code}`) : code) : ''

        return { id: form?.id, name, language, text: name || language || `#${form?.id}` }
    })

    const counts = base.reduce((acc, item) => ({ ...acc, [item.text]: (acc[item.text] || 0) + 1 }), {})

    return base.map((item) => ({
        ...item,
        // Aynı metne düşen birden fazla form varsa hepsine id eklenir.
        suffix: counts[item.text] > 1 ? `#${item.id}` : '',
    }))
}

export default function FormDownload({ appointmentId, unitId }) {
    const [pdf, setPdf] = useState('')
    const [unit, setUnit] = useState({
        unitForms: []
    })

    const onClick = async (item) => {
        if (item.key === 'pdf') {
            await downloadPdf()
        }
        else if (item.key === 'word') {
            await downloadWord()
        }
        else if (item.key === 'print') {
            await print()
        }
    }

    const downloadPdf = async (formId) => {
        const res = await ApiService.Appointment.GetOnamFormPdf(appointmentId, formId);

        if (res.success) {
            Helper.File.saveFile({
                blobLink: res.data,
                fileName: res.fileName
            })
        }
    }

    const downloadWord = async (formId) => {
        const res = await ApiService.Appointment.GetOnamFormWord(appointmentId, formId);

        if (res.success) {
            Helper.File.saveFile({
                blobLink: res.data,
                fileName: res.fileName
            })
        }
    }

    const print = async (e, formId) => {
        e.stopPropagation()
        const res = await ApiService.Appointment.GetOnamFormPdf(appointmentId, formId);
        if (res.success) {
            setPdf(res.data)
        }
    }

    const labels = buildFormLabels(unit?.unitForms)

    const menu2 = (
        <Menu>
            {
                unit?.unitForms?.map((form, index) => (
                    <Menu.Item key={form.id}>
                        {/* Formu ayırt eden şey ADIDIR; ad yoksa dil, çakışırsa id eklenir. */}
                        {labels[index]?.name
                            ? <>{labels[index].name}<span style={{ color: '#8c8c8c', marginLeft: 6 }}>· {labels[index].language}</span></>
                            : labels[index]?.text}
                        {labels[index]?.suffix && (
                            <span style={{ color: '#bfbfbf', marginLeft: 6 }}>{labels[index].suffix}</span>
                        )}
                        <Space style={{ marginLeft: 8 }}>
                            <Button
                                size={'small'}
                                onClick={(e) => print(e, form.id)}>
                                {t('Print')}
                            </Button>
                            <Button
                                size={'small'}
                                onClick={() => downloadPdf(form.id)}>
                                {t('Pdf')}
                            </Button>
                            <Button
                                size={'small'}
                                onClick={() => downloadWord(form.id)}>
                                {t('Word')}
                            </Button>
                        </Space>
                    </Menu.Item>
                ))
            }
        </Menu>
    )

    const getUnit = async () => {
        if (unitId) {
            const res = await ApiService.Unit.GetUnit(unitId);
            if (res.success) {
                setUnit(res.data)
            }
        }
    }

    useEffect(() => {
        getUnit()
    }, [appointmentId, unitId]);

    return (
        <>
            <Dropdown size={'small'} overlay={menu2} placement="bottomRight">
                <Button size="small">
                    <DownOutlined />
                    {t('Onam Form')}
                </Button>
            </Dropdown>
            <iframe id={'print-pdf'} src={pdf} style={{ display: 'none' }} onLoad={(e) => {
                if (pdf) {
                    const frameWindow = e.target.contentWindow;
                    frameWindow.focus();
                    frameWindow.print();
                }
            }} />
        </>
    )
}